<template>
  <router-view />
</template>

<script>
export default {
    name: 'App',

};
</script>

<style>
html, body, .v-application {
  font-family: 'Poppins', 'Roboto', sans-serif !important;
}

.v-application.theme--light {
  background-color: #F4F6FB !important;
}

.v-card {
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(30, 60, 114, 0.08);
}

.v-alert {
  border-radius: 12px !important;
}

.v-chip {
  font-weight: 600;
}

.v-data-table {
  border-radius: 14px;
  overflow: hidden;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background: #F4F6FB;
  color: #1E3C72 !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-size: 0.72rem;
  text-transform: uppercase;
  border-bottom: 2px solid #E3E8F4 !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
  background: #F4F6FB !important;
}

/* Premium page chrome helpers, reused across module pages */
.page-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.stat-chip-row {
  gap: 10px;
}
.stat-chip {
  background: #F4F6FB;
  border-radius: 12px;
  padding: 6px 16px;
  text-align: center;
  min-width: 88px;
}
.stat-chip-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: #1E3C72;
  line-height: 1.2;
}
.stat-chip-label {
  font-size: 0.62rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #607D8B;
  font-weight: 600;
}
.stat-chip-success .stat-chip-value { color: #2E7D32; }
.stat-chip-error .stat-chip-value { color: #C62828; }
.stat-chip-warning .stat-chip-value { color: #F9A825; }

/* Premium modal chrome, reused across dialogs */
.modal-header-gradient {
  background: linear-gradient(135deg, #1E3C72 0%, #14233F 100%) !important;
}
.modal-close-btn {
  background: rgba(255, 255, 255, 0.14) !important;
  transition: background-color 0.2s ease;
}
.modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.26) !important;
}
.modal-card-title {
  background: linear-gradient(135deg, #1E3C72 0%, #14233F 100%);
  color: #fff;
  border-radius: 14px 14px 0 0;
}
.modal-card-title .v-icon {
  color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background: #c7cfe2;
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
</style>